import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCurrentUser } from "../lib/auth";

type AuthNavProps = {
  className?: string;
};

export function AuthNav({ className }: AuthNavProps) {
  const [state, setState] = useState<"loading" | "guest" | "user">("loading");
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    let ignore = false;

    async function load() {
      try {
        const current = await fetchCurrentUser();
        if (ignore) return;

        if (current.authenticated && current.user) {
          setState("user");
          setRole(current.user.role);
          return;
        }

        setState("guest");
      } catch {
        if (!ignore) setState("guest");
      }
    }

    void load();
    return () => { ignore = true; };
  }, []);

  if (state === "loading") return null;

  const linkClass = className || "hover:text-nv-ink transition-colors focus:outline-none";

  if (state === "guest") {
    return (
      <Link className={linkClass} to="/auth/login">
        Login
      </Link>
    );
  }

  const rolePath = role === "ADMIN" ? "/admin" : role === "SALES" ? "/sales" : "/shop";
  const roleLabel = role === "ADMIN" ? "Admin Console" : role === "SALES" ? "Sales Console" : "Account";

  return (
    <div className="flex items-center gap-4">
      <Link className={linkClass} to={rolePath}>
        {roleLabel}
      </Link>
      <form action="/api/auth/logout/form" method="post">
        <button className={linkClass} type="submit">
          Logout
        </button>
      </form>
    </div>
  );
}
